<div class="cr-page">
  <div class="cr-head">
    <div>
      <h1>{{ id ? 'Edit message template' : 'New message template' }}</h1>
      <p>Save a message your team sends often. It shows up under “Start from” when composing.</p>
    </div>
    <button mat-stroked-button type="button" class="cr-preview-toggle" (click)="togglePreview()" [attr.aria-pressed]="showPreview">
      <mat-icon>{{ showPreview ? 'visibility_off' : 'visibility' }}</mat-icon>{{ showPreview ? 'Hide preview' : 'Show preview' }}
    </button>
  </div>

  <div class="cr-grid" [class.no-preview]="!showPreview">
    <form class="cr-card" [formGroup]="form" novalidate>
      <div class="cr-section">
        <div class="cr-sec-title"><span class="n">1</span>About this template</div>
        <mat-form-field appearance="outline" class="cr-full">
          <mat-label>Template name</mat-label>
          <input matInput formControlName="name" autocomplete="off">
          <mat-hint>Only staff see this name.</mat-hint>
          <mat-error>Give the template a name</mat-error>
        </mat-form-field>
        <div class="cr-toggle">
          <mat-slide-toggle formControlName="active" aria-labelledby="t-active-label"></mat-slide-toggle>
          <div id="t-active-label"><b>Show in Compose</b><br><span class="cr-hint">Turn off to keep the template without offering it to staff.</span></div>
        </div>
      </div>

      <div class="cr-section">
        <div class="cr-sec-title"><span class="n">2</span>The message</div>
        <mat-form-field appearance="outline" class="cr-full" subscriptSizing="dynamic">
          <mat-label>Subject</mat-label>
          <input matInput formControlName="subject" autocomplete="off">
          <mat-error>Subject is required</mat-error>
        </mat-form-field>
        <div class="cr-field">
          <div class="cr-label-row">
            <span class="cr-label">Message</span>
            <app-insert-variable [tokens]="tokens" (pick)="insertToken($event)"></app-insert-variable>
          </div>
          <app-html-editor #editor formControlName="body" [cidSource]="files" (addImage)="files?.openImagePicker()" (attachFile)="files?.openFilePicker()"
            [invalid]="!!(form.get('body')?.invalid && form.get('body')?.touched)"></app-html-editor>
          @if (form.get('body')?.hasError('required') && form.get('body')?.touched) {
            <mat-error>Message is required</mat-error>
          }
        </div>
        <app-correspondence-files [existing]="template?.attachments" (insertImage)="insertImage($event)"></app-correspondence-files>
      </div>
    </form>

    <aside class="cr-preview">
      <div class="cr-preview-head"><strong>Preview</strong><span class="cr-hint">Sample customer</span></div>
      <app-email-preview [subject]="form.value.subject" [body]="form.value.body" [cidUrls]="files?.cidUrls ?? {}"></app-email-preview>
      <p class="cr-hint">Customer info is filled in for each recipient when the message is sent.</p>
    </aside>
  </div>

  <div class="cr-actions">
    <button mat-button type="button" (click)="goBack()"><mat-icon>close</mat-icon>Cancel</button>
    <div class="cr-right">
      @if (form.dirty) { <span class="cr-note"><mat-icon>info</mat-icon>Unsaved changes</span> }
      <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving">
        <mat-icon>save</mat-icon>{{ saving ? 'Saving…' : 'Save template' }}
      </button>
    </div>
  </div>
</div>
